module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "inventory"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Inventory',
      "path": '/inventory'
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.beforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('InventoryForm', {
    ref: "form",
    attrs: {
      "title": 'Add Inventory'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_vm._l((_vm.validationErrors), function(error) {
    return _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\n                " + _vm._s(error.msg) + "\n              ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-simple btn-link btn-wd",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel\n              ")]), _vm._v(" "), _vm._m(0)], 2)])])])]), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac7943d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/add.vue
// module id = 698
// module chunks = 0